import classNames from 'classnames'
import React, { useState } from 'react'
import SVGIcon from '../svg/SVGIcon'
import { buildStyleAttributes } from '../utils/css'
import { getImageUrl } from '../utils/image'
import s from './RouteLabelComponents.less'

export const RouteLabelTextComponent = ({ component }) => {
  const attributes = {
    className: s.labelComponent
  }
  if (component.color || component.size) {
    attributes.style = buildStyleAttributes({
      color: component.color,
      fontSize: component.size === 'small' ? '0.7em' : undefined
    })
  }
  return <span {...attributes}>{component.text}</span>
}

const RouteLabelPictoComponent = ({ component }) => {
  const attributes = {
    className: classNames('icon', s.labelComponent),
    style: component.color && { fill: component.color }
  }
  return (
    <span {...attributes}>
      <SVGIcon icon={component.picto_id} />
    </span>
  )
}

const RouteLabelExposantComponent = ({ component }) => {
  const attributes = {
    className: classNames(s.labelComponent, s.exposant),
    style: component.color && { fill: component.color }
  }
  return (
    <span {...attributes}>
      <SVGIcon icon={component.picto_id} />
    </span>
  )
}

export const RouteLabelPictoUrlComponent = ({ component }) => (
  <RouteLabelImageComponent component={component} url={getImageUrl(component.url)} classes={[s.pictoUrl]} />
)

const getWebLogoUrl = logos => {
  const logo =
    logos.find(({ platform }) => platform === 'web_retina') || logos.find(({ platform }) => platform === 'web') || {}
  return logo.image
}

const RouteLabelLogosComponent = ({ component }) => (
  <RouteLabelImageComponent component={component} url={getWebLogoUrl(component.logos)} />
)

export const RouteLabelImageComponent = ({ component, url, classes = [] }) => {
  const [error, setError] = useState(false)

  const onError = () => {
    setError(true)
  }

  if (error) {
    if (component.fallback) return <RouteLabelComponents components={component.fallback} />

    return component.text ? <RouteLabelTextComponent component={{ text: component.text }} /> : ''
  }

  return (
    <span className={classNames(s.labelComponent, ...classes)}>
      <img src={url} onError={onError} />
    </span>
  )
}

const COMPONENTS_BY_TYPE = {
  text: RouteLabelTextComponent,
  logos: RouteLabelLogosComponent,
  picto: RouteLabelPictoComponent,
  picto_url: RouteLabelPictoUrlComponent,
  exposant: RouteLabelExposantComponent
}

export const RouteLabelComponents = ({ components, backgroundColor }) => {
  const attributes = { style: backgroundColor && { backgroundColor, borderRadius: '4px', padding: '0 4px' } }

  const componentsContent = components?.map((component, idx) => {
    const ComponentClass = COMPONENTS_BY_TYPE[component.type]
    if (!ComponentClass) {
      console.warn('unknown component type:', component.type)
      return ''
    }
    return <ComponentClass component={component} key={idx} />
  })

  return backgroundColor ? (
    <span className={s.labelWithBackgroundContainer} {...attributes}>
      {componentsContent}
    </span>
  ) : (
    <>{componentsContent}</>
  )
}

export default RouteLabelComponents
